import { fetchAll, fetchFiltered, add, edit, show } from '@/api/group'

const state = {
  all: [],
  isLoading: false,
  groupById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const groups = await fetchAll()
      commit('setAll', groups)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const group = await show(id)
      commit('setGroupById', group)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const groups = await fetchFiltered(queriesParams)
      commit('setAll', groups)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, group) {
    commit('setLoading', true)
    try {
      await add(group)
      return true
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  setAll (state, groups) {
    state.all = groups
  },

  setGroupById (state, group) {
    const { id, name, company, permissions, users } = group
    state.groupById = { id, name, company, permissions, users }
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },

  cleanState (state) {
    state.all = []
    state.isLoading = false
    state.groupById = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
